<modal-form-container title="New tag" [showModal]="true" (closeModalEvent)="close()">
  <form class="gf" [formGroup]="tagForm" (ngSubmit)="handleSubmit()" novalidate>
    <p class="gf__lead">A label for contacts you message together, such as “VIP” or “Gaborone stores”.</p>

    <div class="gf__grid">
      <input-field class="gf__wide" label="Name" [errorMessage]="nameError">
        <input class="input-style" formControlName="name" />
      </input-field>

      <input-field class="gf__wide" label="Description" hint="Optional. When to use this tag.">
        <textarea class="input-style" formControlName="description" rows="3"></textarea>
      </input-field>
    </div>

    @if (saveError) {
      <p class="gf__error" role="alert">
        <span class="bk-sym" aria-hidden="true">error</span>
        {{ saveError }}
      </p>
    }

    <div class="gf__foot">
      <customizable-button title="Cancel" (click)="close()" type="button" [outline]="true" />
      <customizable-button title="Create tag" type="submit" [loading]="contactServiceLoading" />
    </div>
  </form>
</modal-form-container>
